import { FooterPortal, NavbarPortal, SearchPortal } from "components";
import React, { useCallback, useEffect, useState } from "react";
import { FaFolderOpen, FaRegClock, FaRegHdd } from "react-icons/fa";
import { Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { API_URL_kbArticleshow, API_URL_kbCategory } from "constants/api";
import { kbArticleReducers } from "redux/kbArticleSlice";
import { getData } from "actions";
import { useDispatch, useSelector } from "react-redux";
import { kbCategoryReducers } from "redux/kbCategorySlice";

const Show = () => {
  const { slug } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const state = location.state ? location.state : "";

  const { getKbArticleResult, getKbCategoryResult } = useSelector((state) => ({
    getKbArticleResult: state.kbArticle.getKbArticleResult,
    getKbCategoryResult: state.kbCategory.getKbCategoryResult,
  }));

  const getKbArticle = useCallback(
    async (params) => {
      getData(
        API_URL_kbArticleshow,
        params,
        { dispatch, redux: kbArticleReducers },
        "GET_KBARTICLE"
      );
    },
    [dispatch]
  );

  const getKbCategory = useCallback(
    async (params) => {
      getData(
        API_URL_kbCategory,
        params,
        { dispatch, redux: kbCategoryReducers },
        "GET_KBCATEGORY"
      );
    },
    [dispatch]
  );

  const fetchData = useCallback(() => {
    const params = `${slug}/`;
    getKbArticle(params);
  }, [getKbArticle]);

  useEffect(() => {
    const params = `?limit=${9999999}`;
    getKbCategory(params);
    fetchData();
  }, []);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <main className="flex flex-grow">
          <div className="w-full">
            <NavbarPortal current={"Pertanyaan & Jawaban"} />
            <SearchPortal excludedPaths={"artikel"} />

            <div className="mx-auto w-full max-w-[90rem] md:px-8 bg-transparent">
              <div className="relative min-h-[65vh] mx-1 md:mx-0 bottom-6 bg-neutral-50 shadow-sm shadow-sky-800 rounded">
                <div className="mx-4 md:mx-10 py-2 md:py-4 grid grid-cols-12">
                  <div className="col-span-12 md:col-span-9">
                    <p className="text-black text-2xl font-bold mb-2">
                      {getKbArticleResult.data && getKbArticleResult.data.name}
                    </p>
                    <div className="flex flex-wrap items-center text-sm mb-2">
                      <FaRegClock className="mr-1" />
                      <span className="mr-4">
                        {moment(
                          getKbArticleResult.data &&
                            getKbArticleResult.data.created_at
                        ).format("dddd, D MMMM YYYY")}
                      </span>
                      <FaFolderOpen className="mr-1" />
                      <span>
                        {state.category_name ? state.category_name : ""}
                      </span>
                    </div>
                    <hr className="mb-4 border border-gray-300 w-11/12" />

                    <div
                      className="mr-5 ck-editor-content"
                      dangerouslySetInnerHTML={{
                        __html:
                          getKbArticleResult.data &&
                          getKbArticleResult.data.description,
                      }}
                    ></div>
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <div className="flex flex-row justify-between items-center">
                      <h2 className="text-black text-xl font-bold ">
                        Kategori
                      </h2>
                      <FaRegHdd />
                    </div>
                    <hr className="mb-4 border border-gray-300" />
                    {getKbCategoryResult.results &&
                      getKbCategoryResult.results.map((items, index) => (
                        <Link
                          to="/pertanyaan"
                          state={{
                            category: items.id,
                            category_name: items.name,
                          }}
                          key={index}
                          className={`mb-1 flex flex-row justify-between items-center border p-1 hover:bg-slate-100 cursor-pointer
                        ${state.category === items.id ? "bg-slate-200" : ""}
                        `}
                        >
                          <p className="">{items.name}</p>
                          <span className="bg-sky-600 text-white rounded px-1 h-6">
                            {items.count}
                          </span>
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default Show;
